import './BulkSelectionToolbar.css';
import { Button } from '@/components/ui/Button/Button';
import { DeleteIcon, FaMessengerIcon, CloseIcon } from '@/components/ui/Icons';

interface BulkSelectionToolbarProps {
  selectedCount: number;
  canDeleteCount: number;
  onDelete: () => void;
  onForward: () => void;
  onCancel: () => void;
}

/** Только контент строки — оболочка `chatAssistant__inputArea` задаётся в MessengerComposerLayout */
export function BulkSelectionToolbar({
  selectedCount,
  canDeleteCount,
  onDelete,
  onForward,
  onCancel,
}: BulkSelectionToolbarProps) {
  return (
    <>
      <span className="bulkSelectionToolbar__count">
        {selectedCount === 0
          ? 'Выберите сообщения'
          : `Выбрано: ${selectedCount}`}
      </span>
      <div className="bulkSelectionToolbar__actions">
        {canDeleteCount > 0 && (
          <Button
            type="button"
            variant="dangerOutline"
            size="s"
            onClick={onDelete}
            title="Удалить выбранные"
          >
            <span className="bulkSelectionToolbar__btnInner">
              <DeleteIcon size={18} />
              <span>Удалить</span>
            </span>
          </Button>
        )}
        {selectedCount > 0 && (
          <Button
            type="button"
            variant="primary"
            size="s"
            onClick={onForward}
            title="Переслать выбранные"
          >
            <span className="bulkSelectionToolbar__btnInner">
              <FaMessengerIcon icon="share" size={18} />
              <span>Переслать</span>
            </span>
          </Button>
        )}
      </div>
      <button
        type="button"
        className="chatAssistant__close"
        onClick={onCancel}
        aria-label="Отменить выбор"
      >
        <CloseIcon size={20} />
      </button>
    </>
  );
}
